import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="benefit-modal"
export default class extends Controller {
  // リセットボタン
  reset(): void {
    // モーダル内の全てのチェックボックスを取得
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
    // 全てのチェックボックスをOFFにする
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    })
  }

  // 「決定する」ボタンクリック時の処理
  submitBenefitSettings(): void {
    // 選択した job_benefits.name と job_benefits.id を取得
    const selectedCheckboxes = Array.from(document.querySelectorAll('input[name="benefit"]:checked')) as HTMLInputElement[];
    const selectedNames = selectedCheckboxes.map(checkbox => checkbox.nextElementSibling?.textContent || '').join(' / ');
    const selectedValues = selectedCheckboxes.map(checkbox => checkbox.value).join(',');

    // 選択した job_benefits.name のリストを表示する箇所
    const selectedNamesElement = document.getElementById('selected_benefit_names') as HTMLParagraphElement;
    selectedNamesElement.textContent = selectedNames || '選択してください';

    // 選択した job_benefits.id のリストをフォームのhiddenフィールドにセット
    const selectedIdsElement = document.getElementById('default_benefit_ids') as HTMLInputElement;
    selectedIdsElement.value = selectedValues;

    // モーダルを閉じる
    Modal.getOrCreateInstance(document.getElementById('selectBenefitModal') as HTMLElement).hide();
  }
}
